// import React, { useState } from "react";
// import {
//   Box,
//   Grid,
//   TextField,
//   Typography,
//   Button,
//   Container,
//   CssBaseline,
//   IconButton,
//   InputAdornment,
//   Snackbar,
//   Alert,
//   Paper,
//   Divider,
// } from "@mui/material";
// import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
// import Visibility from "@mui/icons-material/Visibility";
// import VisibilityOff from "@mui/icons-material/VisibilityOff";
// import axios from "axios";
// import Header from "../../Component/Header";

// const CustomerForm = ({ role = "Customer" }) => {
//   const [customer, setCustomer] = useState({
//     customerName: "",
//     address: "",
//     preferredAddress: "",
//     contactNumber: "",
//     email: "",
//     whatsapp: "",
//     username: "",
//     password: "",
//   });

//   const [errors, setErrors] = useState({});
//   const [showPassword, setShowPassword] = useState(false);
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });

//   // ✅ Validation
//   const validate = () => {
//     const newErrors = {};
//     if (!customer.customerName) newErrors.customerName = "Customer name is required";
//     if (!customer.email || !/\S+@\S+\.\S+/.test(customer.email)) newErrors.email = "Valid email required";
//     if (!customer.contactNumber || !/^\d{10}$/.test(customer.contactNumber)) newErrors.contactNumber = "10-digit number required";
//     if (!customer.whatsapp || !/^\d{10}$/.test(customer.whatsapp)) newErrors.whatsapp = "10-digit WhatsApp number required";
//     if (!customer.address) newErrors.address = "Address is required";
//     if (!customer.username) newErrors.username = "Username is required";
//     if (!customer.password || customer.password.length < 6) newErrors.password = "Min 6 characters required";

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   // ✅ Handle input
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setCustomer({ ...customer, [name]: value });
//   };

//   // ✅ Handle form submit
// //   const handleSubmit = (e) => {
// //   e.preventDefault();
// //   if (!validate()) return;

// // axios.post(`https://sakhisshop.com/api/customers/register?role=${role}`, customer, {

// //     withCredentials: true,
// //     headers: { "Content-Type": "application/json" },
// //   })
// //     .then((res) => {
// //       if (res.data && res.data.error) {
// //         // ❌ Backend returned error (Admin disabled customer creation)
// //         setSnackbar({ open: true, message: res.data.error, severity: "error" });
// //         return;
// //       }

// //       // ✅ Success
// //       setSnackbar({ open: true, message: "🎉 Customer registered successfully!", severity: "success" });
// //       setCustomer({
// //         customerName: "",
// //         address: "",
// //         preferredAddress: "",
// //         contactNumber: "",
// //         email: "",
// //         whatsapp: "",
// //         username: "",
// //         password: "",
// //       });
// //       setErrors({});
// //     })
// //     .catch((error) => {
// //       let msg = "Something went wrong! Please try again.";
// //       if (error.response && error.response.data && error.response.data.error) {
// //         msg = error.response.data.error;
// //       }
// //       setSnackbar({ open: true, message: msg, severity: "error" });
// //     });
// // };

// const handleSubmit = (e) => {
//   e.preventDefault();
//   if (!validate()) return;

//   axios.post(`https://sakhisshop.com/api/customers/register?role=${role}`, customer, {
//     withCredentials: true,
//     headers: { "Content-Type": "application/json" },
//   })
//     .then((res) => {
//       if (res.data && res.data.error) {
//         setSnackbar({ open: true, message: res.data.error, severity: "error" });
//         return;
//       }

//       // 👇 yaha cID save karna hai
//       if (res.data && res.data.cID) {
//         localStorage.setItem("cID", res.data.cID);
//       }

//       setSnackbar({
//         open: true,
//         message: "🎉 Customer registered successfully!",
//         severity: "success",
//       });

//       // Reset form
//       setCustomer({
//         customerName: "",
//         address: "",
//         preferredAddress: "",
//         contactNumber: "",
//         email: "",
//         whatsapp: "",
//         username: "",
//         password: "",
//       });
//       setErrors({});
//     })
//     .catch((error) => {
//       let msg = "Something went wrong! Please try again.";
//       if (error.response && error.response.data && error.response.data.error) {
//         msg = error.response.data.error;
//       }
//       setSnackbar({ open: true, message: msg, severity: "error" });
//     });
// };

//   return (
//     <>
//       <CssBaseline />
//       <Header />

//       <Box sx={{ background: "#f4f6f8", flex: 1, py: 5 }}>
//         <Container maxWidth={false} sx={{ maxWidth: "1100px" }}>
//           {/* Snackbar */}
//           <Snackbar
//             open={snackbar.open}
//             autoHideDuration={3000}
//             onClose={() => setSnackbar({ ...snackbar, open: false })}
//             anchorOrigin={{ vertical: "top", horizontal: "center" }}
//           >
//             <Alert severity={snackbar.severity} sx={{ width: "100%" }}>
//               {snackbar.message}
//             </Alert>
//           </Snackbar>

//           <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
//             {/* Header */}
//             <Box sx={{ mb: 4, display: "flex", alignItems: "center", gap: 2 }}>
//               <PersonAddAlt1Icon sx={{ fontSize: 40, color: "primary.main" }} />
//               <Box>
//                 <Typography variant="h5" fontWeight="bold">
//                   {role} Registration
//                 </Typography>
//                 <Typography variant="body2" color="text.secondary">
//                   Fill out the form below to register a new {role.toLowerCase()}.
//                 </Typography>
//               </Box>
//             </Box>

//             <Divider sx={{ mb: 3 }} />

//             <form onSubmit={handleSubmit}>
//               <Grid container spacing={3}>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     label="Customer Name"
//                     name="customerName"
//                     value={customer.customerName}
//                     onChange={handleChange}
//                     error={!!errors.customerName}
//                     helperText={errors.customerName}
//                     fullWidth
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     label="Email"
//                     name="email"
//                     value={customer.email}
//                     onChange={handleChange}
//                     error={!!errors.email}
//                     helperText={errors.email}
//                     fullWidth
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     label="Contact Number"
//                     name="contactNumber"
//                     value={customer.contactNumber}
//                     onChange={handleChange}
//                     error={!!errors.contactNumber}
//                     helperText={errors.contactNumber}
//                     fullWidth
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     label="WhatsApp Number"
//                     name="whatsapp"
//                     value={customer.whatsapp}
//                     onChange={handleChange}
//                     error={!!errors.whatsapp}
//                     helperText={errors.whatsapp}
//                     fullWidth
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     label="Address"
//                     name="address"
//                     value={customer.address}
//                     onChange={handleChange}
//                     error={!!errors.address}
//                     helperText={errors.address}
//                     fullWidth
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     label="Preferred Address"
//                     name="preferredAddress"
//                     value={customer.preferredAddress}
//                     onChange={handleChange}
//                     error={!!errors.preferredAddress}
//                     helperText={errors.preferredAddress}
//                     fullWidth
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     label="Username"
//                     name="username"
//                     value={customer.username}
//                     onChange={handleChange}
//                     error={!!errors.username}
//                     helperText={errors.username}
//                     fullWidth
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     label="Password"
//                     name="password"
//                     type={showPassword ? "text" : "password"}
//                     value={customer.password}
//                     onChange={handleChange}
//                     error={!!errors.password}
//                     helperText={errors.password}
//                     fullWidth
//                     InputProps={{
//                       endAdornment: (
//                         <InputAdornment position="end">
//                           <IconButton onClick={() => setShowPassword((prev) => !prev)} edge="end">
//                             {showPassword ? <VisibilityOff /> : <Visibility />}
//                           </IconButton>
//                         </InputAdornment>
//                       ),
//                     }}
//                   />
//                 </Grid>
//               </Grid>

//               <Box textAlign="center" mt={4}>
//                 <Button
//                   type="submit"
//                   variant="contained"
//                   size="large"
//                   sx={{
//                     textTransform: "none",
//                     fontWeight: "bold",
//                     px: 4,
//                     borderRadius: 2,
//                     boxShadow: 1,
//                   }}
//                 >
//                   Register
//                 </Button>
//               </Box>
//             </form>
//           </Paper>
//         </Container>
//       </Box>
//     </>
//   );
// };

// export default CustomerForm;

import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  Grid,
  TextField,
  Typography,
  Button,
  Container,
  CssBaseline,
  IconButton,
  InputAdornment,
  Snackbar,
  Alert,
  Paper,
  Divider,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import axios from "axios";
import Header from "../../Component/Header";

const CustomerForm = ({ role = "Customer" }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [customer, setCustomer] = useState({
    customerName: "",
    address: "",
    preferredAddress: "",
    contactNumber: "",
    email: "",
    whatsapp: "",
    username: "",
    password: "",
  });
  const inputStyle = {
    "& .MuiOutlinedInput-root": {
      borderRadius: 2,
      backgroundColor: "#f9fafb",
      transition: "0.3s",
      "&:hover fieldset": {
        borderColor: "#6366f1",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#4f46e5",
        borderWidth: 2,
      },
    },
  };

  const [sameAsContact, setSameAsContact] = useState(false);
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  // ✅ Validation
  const validate = () => {
    const newErrors = {};

    // 📱 Mobile number mandatory (Login ID)
    if (!customer.contactNumber || !/^\d{10}$/.test(customer.contactNumber)) {
      newErrors.contactNumber = "Valid 10-digit mobile number required";
    }

    // 📧 Email mandatory
    if (!customer.email || !/\S+@\S+\.\S+/.test(customer.email)) {
      newErrors.email = "Valid email address required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // const validate = () => {
  //   const newErrors = {};
  //   if (!customer.customerName) newErrors.customerName = "Customer name is required";
  //   if (!customer.email || !/\S+@\S+\.\S+/.test(customer.email))
  //     newErrors.email = "Valid email required";
  //   if (!customer.contactNumber || !/^\d{10}$/.test(customer.contactNumber))
  //     newErrors.contactNumber = "10-digit number required";

  //   if (!sameAsContact && (!customer.whatsapp || !/^\d{10}$/.test(customer.whatsapp)))
  //     newErrors.whatsapp = "10-digit WhatsApp number required";

  //   if (!customer.address) newErrors.address = "Address is required";
  //   if (!customer.username) newErrors.username = "Username is required";
  //   if (!customer.password || customer.password.length < 6)
  //     newErrors.password = "Min 6 characters required";

  //   setErrors(newErrors);
  //   return Object.keys(newErrors).length === 0;
  // };

  // ✅ Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    // Auto-sync WhatsApp if sameAsContact is true
    if (name === "contactNumber" && sameAsContact) {
      setCustomer({ ...customer, contactNumber: value, whatsapp: value });
    } else {
      setCustomer({ ...customer, [name]: value });
    }
  };

  // ✅ Checkbox logic
  const handleCheckbox = (e) => {
    const checked = e.target.checked;
    setSameAsContact(checked);
    if (checked) {
      setCustomer((prev) => ({ ...prev, whatsapp: prev.contactNumber }));
    } else {
      setCustomer((prev) => ({ ...prev, whatsapp: "" }));
    }
  };

  // ✅ Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    let customerId;

    try {
      // 🔵 REGISTER CUSTOMER
      const payload = {
        ...customer,
        username: customer.contactNumber, // 🔥 LOGIN ID
      };

      const res = await axios.post(
        `https://sakhisshop.com/api/customers/register?role=${role}`,
        payload,
      );

      // 🔥 MAP BACKEND → FRONTEND
      customerId = res.data?.cID;
      if (!customerId) throw new Error("Customer ID not returned");

      // ✅ ONLY THIS KEY
      localStorage.setItem("customerId", String(customerId));

      setSnackbar({
        open: true,
        message: "🎉 Registration successful!",
        severity: "success",
      });

      // reset form
      setCustomer({
        customerName: "",
        address: "",
        preferredAddress: "",
        contactNumber: "",
        email: "",
        whatsapp: "",
        username: customer.contactNumber,
        password: "",
      });
      setErrors({});
      setSameAsContact(false);
    } catch (err) {
      setSnackbar({
        open: true,
        message: err.response?.data?.error || "Registration failed",
        severity: "error",
      });
      return;
    }

    // 🟡 JOIN SHOP IF QR FLOW
    try {
      const params = new URLSearchParams(location.search);
      const shopId = Number(params.get("shopId"));

      if (shopId && !isNaN(shopId)) {
        await axios.post(
          `https://sakhisshop.com/api/customers/${customerId}/join-shop/${shopId}`,
        );

        await axios.post(
          `https://sakhisshop.com/api/customers/${customerId}/preferredShops/${shopId}`,
        );
      }
    } catch (err) {
      console.warn("Shop join failed:", err);
    }

    // 🚀 DASHBOARD ONLY
    navigate("/customer-dashboard", { replace: true });
  };
  return (
    <>
      <CssBaseline />
      <Header />

      <Box
        sx={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #eef2f7, #f9fafb)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          py: 6,
        }}
      >
        <Container maxWidth={false} sx={{ maxWidth: 1000 }}>
          {/* Snackbar */}
          <Snackbar
            open={snackbar.open}
            autoHideDuration={3000}
            onClose={() => setSnackbar({ ...snackbar, open: false })}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Alert severity={snackbar.severity} sx={{ width: "100%" }}>
              {snackbar.message}
            </Alert>
          </Snackbar>

          <Paper
            elevation={0}
            sx={{
              p: { xs: 3, sm: 5 },
              borderRadius: 4,
              border: "1px solid #e5e7eb",
              background: "#ffffff",
            }}
          >
            {/* Header */}
            <Box sx={{ mb: 4, textAlign: "center" }}>
              <PersonAddAlt1Icon
                sx={{ fontSize: 46, color: "primary.main", mb: 1 }}
              />
              <Typography variant="h5" fontWeight={700}>
                {role} Registration
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Enter your details to create an account
              </Typography>
            </Box>

            <Divider sx={{ mb: 4 }} />

            <form onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Customer Name"
                    name="customerName"
                    value={customer.customerName}
                    onChange={handleChange}
                    error={!!errors.customerName}
                    helperText={errors.customerName}
                    fullWidth
                    sx={inputStyle}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Email"
                    name="email"
                    value={customer.email}
                    onChange={handleChange}
                    error={!!errors.email}
                    helperText={errors.email}
                    fullWidth
                    sx={inputStyle}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Contact Number"
                    name="contactNumber"
                    value={customer.contactNumber}
                    onChange={handleChange}
                    error={!!errors.contactNumber}
                    helperText={errors.contactNumber}
                    fullWidth
                    sx={inputStyle}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  {!sameAsContact && (
                    <TextField
                      label="WhatsApp Number"
                      name="whatsapp"
                      value={customer.whatsapp}
                      onChange={handleChange}
                      error={!!errors.whatsapp}
                      helperText={errors.whatsapp}
                      fullWidth
                      sx={inputStyle}
                    />
                  )}
                  <FormControlLabel
                    sx={{ mt: 1 }}
                    control={
                      <Checkbox
                        checked={sameAsContact}
                        onChange={handleCheckbox}
                        color="primary"
                      />
                    }
                    label="Same as contact number"
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Address"
                    name="address"
                    value={customer.address}
                    onChange={handleChange}
                    error={!!errors.address}
                    helperText={errors.address}
                    fullWidth
                    sx={inputStyle}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Preferred Address"
                    name="preferredAddress"
                    value={customer.preferredAddress}
                    onChange={handleChange}
                    fullWidth
                    sx={inputStyle}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Login ID (Mobile Number)"
                    name="username"
                    value={customer.contactNumber}
                    onChange={handleChange}
                    error={!!errors.username}
                    helperText={errors.username}
                    fullWidth
                    sx={inputStyle}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Password"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    value={customer.password}
                    onChange={handleChange}
                    error={!!errors.password}
                    helperText={errors.password}
                    fullWidth
                    sx={inputStyle}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              </Grid>

              {/* Submit */}
              <Button
                type="submit"
                fullWidth
                sx={{
                  mt: 4,
                  py: 1.4,
                  fontWeight: 700,
                  borderRadius: 3,
                  color: "white",
                  textTransform: "none",
                  background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
                  boxShadow: "0 10px 30px rgba(139, 92, 246, 0.35)",
                  "&:hover": {
                    background: "linear-gradient(135deg, #5b21b6, #6366f1)",
                  },
                }}
              >
                Create Account
              </Button>
            </form>
          </Paper>
        </Container>
      </Box>
    </>
  );
};

export default CustomerForm;
